

import { Component, OnInit, TemplateRef } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-e-canvas',
  templateUrl: './e-canvas.component.html',
  styleUrls: ['./e-canvas.component.scss']
})
export class ECanvasComponent implements OnInit {


  createFilled:boolean = false;
  addDocument:boolean = false;
  openLeftPannel:boolean = false;
  openRightPannel:boolean = false;
  openCenterPannel:boolean = false;

  addformdoc(){
    this.addDocument = !this.addDocument
  }
  createNewFilled(){
    this.createFilled = !this.createFilled;
  }

  getCreateClose(message){
    this.createFilled = message
  }

  openLeft(){
    this.openLeftPannel = !this.openLeftPannel;
  }
  openRight(){
    this.openRightPannel = !this.openRightPannel;
  }
  openCenter(){
    this.openCenterPannel = !this.openCenterPannel;
  }
  constructor(private dialog: MatDialog, ) {}


  ngOnInit(): void {
  }

  


  fillablefiled = [
    'Full Name',
    'First Name',
    'Last Name',
    'Email'
  ]

  todo = [
    {
      role: 'Employee',
      color: 'primary'
    }
  ];

  done = [
    {
      role: 'Admisssion',
      color: 'warn'
    }
  ];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
  }


  timePeriods = [
    'Bronze age',
    'Iron age',
  ];

  

}
